(() => {
  'use strict';
  let touched = false;
  ['pointerdown', 'keydown', 'input'].forEach(name => document.addEventListener?.(name, () => { touched = true; }, {once: true, passive: true}));
  document.querySelectorAll('[data-language-localization]').forEach(form => {
    const select = form.querySelector('[name="language_code"]');
    if (!select) return;
    form.addEventListener('submit', event => {
      const countrySelect = form.querySelector('[name="country_code"]');
      if (countrySelect?.options && [...countrySelect.options].find(option => option.value === countrySelect.value)?.disabled) { event.preventDefault(); return; }
      const manualRegionChange = form.dataset.regionLocalization !== undefined && !['geo', 'saved', 'explicit'].includes(form.dataset.localizationSource);
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) {
        let search = location.search;
        if (manualRegionChange) {
          const parameters = new URLSearchParams(search);
          ['country', 'country_code', 'market', 'lang', 'language', 'locale'].forEach(key => parameters.delete(key));
          parameters.set('country', countrySelect.value);
          parameters.set('lang', select.value);
          search = '?' + parameters.toString();
        }
        returnTo.value = location.pathname + search + (location.hash || '');
      }
      if (manualRegionChange) {
        window.KeepsakeMarket?.rememberPreference({country: countrySelect?.value, language: select.value});
      }
    });
    if (form.dataset.regionLocalization === undefined) {
      select.addEventListener('change', () => {
        if (select.value !== form.dataset.currentLanguage) form.requestSubmit();
      });
    } else {
      form.addEventListener('change', () => { delete form.dataset.localizationSource; });
      const discover = () => { window.KeepsakeMarket?.applyPendingContext?.(); return window.KeepsakeMarket?.discover({form, touched: () => touched}); };
      // Let the configurator attach its draft/photo preservation guard first.
      if (document.readyState === 'complete') discover();
      else document.addEventListener?.('DOMContentLoaded', discover, {once: true});
    }
  });
  document.addEventListener?.('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-region-disclosure][open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
})();
